import DefaultCRUD from '../utils'
const resource = `/naves`;

const { get, create } = DefaultCRUD(resource)

export default {
  get,
  create,
}
